import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

import useAxiosPrivate from '../hooks/useAxiosPrivate'

import logo from '../img/swb-logo.png'

function PaymentSuccess() {
  const axios = useAxiosPrivate()
  const navigate = useNavigate()

  const { serviceName, sessionId } = useParams()

  const [isProcessing, setIsProcessing] = useState(true)

  useEffect(() => {
    if(sessionId) {
      processPayment()
    }
  }, [sessionId])

  const processPayment = async () => {
    try {

      const response = await axios.post('/process-payment', {
        service_name: serviceName,
        session_id: sessionId
      })
      
      let redirectUrl = '/'

      if(serviceName === 'gp-service') {
        redirectUrl = `/book-assessment?serviceKey=${serviceName}`
      } else {
        redirectUrl = `/book-session?serviceKey=${serviceName}`
      }

      navigate(redirectUrl, { replace: true })

    } catch (error) {
      console.error('Error processing payment:', error)
      setIsProcessing(false)
    }
  }

  return (
    <section className="w-screen h-screen py-16">
      <div className="main-bg">&nbsp;</div>
      <div className="flex items-center flex-col z-10 relative">
        <div className="flex">
          <img src={logo} alt="School Wellbeing Logo" className="w-72" />
        </div>
        <div
          className="bg-white rounded-xl shadow-2xl py-10 mt-8 px-8 w-full flex flex-col items-center"
          style={{ maxWidth: 600 }}
        >
          {isProcessing ? (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-wba-primary mb-6"></div>
              <h1 className="text-3xl text-wba-primary font-bold text-center mb-4">
                Processing Payment
              </h1>
              <p className="text-center text-gray-600">
                Please wait while we confirm your payment and set up your service access...
              </p>
            </>
          ) : (
            <>
              <div className="text-green-500 mb-6">
                <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <h1 className="text-3xl text-wba-primary font-bold text-center mb-4">
                Payment Successful!
              </h1>
              <div className="text-center mb-6">
                <p className="text-lg font-semibold text-gray-800 mb-2">
                  Thank you for your purchase of:
                </p>
                <p className="text-xl text-wba-primary font-bold mb-2">
                  {serviceName}
                </p>
              </div>
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 w-full">
                <p className="text-green-800 text-center font-medium">
                  Your service allocations have been added to your account.
                </p>
              </div>
              <div className="text-center">
                <p className="text-gray-600 mb-4">
                  You will be redirected to your dashboard in a few seconds...
                </p>
                <div className="flex items-center justify-center space-x-2">
                  <div className="animate-pulse h-2 w-2 bg-wba-primary rounded-full"></div>
                  <div className="animate-pulse h-2 w-2 bg-wba-primary rounded-full" style={{ animationDelay: '0.2s' }}></div>
                  <div className="animate-pulse h-2 w-2 bg-wba-primary rounded-full" style={{ animationDelay: '0.4s' }}></div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default PaymentSuccess
